module.exports = __webpack_public_path__ + "pc/img/logo1.06e7bf0a.png";